var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05198 2.9755L3.8395 8.59751C3.66469 8.78606 3.37012 8.7972 3.18157 8.62238C3.16804 8.60984 3.15528 8.59651 3.14333 8.58245L1.18893 6.28256C1.02243 6.08663 0.728625 6.06277 0.532692 6.22927C0.33676 6.39577 0.3129 6.68958 0.479399 6.88551L2.4338 9.1854C2.46963 9.22757 2.50793 9.26756 2.54851 9.30518C3.11416 9.82963 3.99786 9.79622 4.5223 9.23057L9.73478 3.60856C9.9096 3.42001 9.89847 3.12544 9.70992 2.95063C9.52136 2.77581 9.2268 2.78695 9.05198 2.9755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneArrowWhite);
export default __webpack_public_path__ + "static/media/oneArrowWhite.fce90b1e63d0b353b65d2a0fedef2638.svg";
export { ForwardRef as ReactComponent };